import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { getMe, login, register } from "../utils/api";
import { setJSON } from "../utils/cart";

export default function Register({ setToken, setCurrentUser }) {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("buyer");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();

    try {
      setLoading(true);
      setMsg("");

      await register({
        username,
        email,
        password,
        role,
        contact: "",
        address: "",
      });

      // auto-login
      const { token } = await login({ email, password });
      setToken(token);

      const me = await getMe(token);
      const u = me?.user || null;

      const user = u
        ? {
            id: u.userId ?? u.id,
            name: u.name ?? u.username ?? username,
            role: String(u.role || role).toLowerCase(),
            email,
          }
        : { id: null, name: username, role, email };

      setCurrentUser(user);
      setJSON("currentUser", user);
      setJSON("authUser", user);

      navigate("/");
    } catch (err) {
      setMsg(err?.message || "Register failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="container pagePadBottom" style={{ maxWidth: 520 }}>
      <div className="card">
        <div style={{ fontWeight: 900, fontSize: 22 }}>Create your account</div>

        <form
          onSubmit={onSubmit}
          style={{ marginTop: 14, display: "grid", gap: 10 }}
        >
          <div>
            <div className="label">Name</div>
            <input
              className="input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Your name"
              required
            />
          </div>

          <div>
            <div className="label">Email</div>
            <input
              className="input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              required
            />
          </div>

          <div>
            <div className="label">Password</div>
            <input
              className="input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>

          <div>
            <div className="label">Role</div>
            <select
              className="input"
              value={role}
              onChange={(e) => setRole(e.target.value)}
            >
              <option value="buyer">Buyer</option>
              <option value="seller">Seller</option>
            </select>
          </div>

          {msg ? (
            <div className="card" style={{ borderLeft: "4px solid #e11d48" }}>
              <div style={{ fontWeight: 900 }}>{msg}</div>
            </div>
          ) : null}

          <button
            className="btnPrimary"
            disabled={loading}
            style={{ justifyContent: "center" }}
          >
            {loading ? "Creating…" : "Create account"}
          </button>
        </form>

        <div className="muted" style={{ marginTop: 12 }}>
          Already have an account? <Link to="/login">Login</Link>
        </div>
      </div>
    </div>
  );
}
